/*
  Project: Stetson Europe
  Author: Luum GmbH
 */

import '../../../../../../node_modules/foundation-sites/dist/js/foundation';
/* import scroller from './modules/scroller'; */
import wikiSearch from './modules/wiki-search';
import '../../../../../../node_modules/bxslider/dist/jquery.bxslider';
import stetson from './additional/stetson';
import imageSlider from './additional/image-slider';
import vidControl from './modules/video';

const $ = require('jquery');

/* scroller(); */
wikiSearch();
stetson();
imageSlider();
vidControl();
$(document).foundation();


// WEBPACK FOOTER //
// ./wp/wp-content/themes/stetson-europe-chisel/src/scripts/app.js